import { light } from '@mui/material/styles/createPalette';

const config = {
  API_URL: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://127.0.0.1:8080' : '',

  //API_URL: 'http://127.0.0.1:8080',
  // API_URL: 'http://192.168.1.61:8080',
  //API_URL: 'http://192.168.100.44:8080',
  theme_light_primary_main: '#1679AB',
  theme_light_secondary_main: '#FF5F00',

  theme_light_primary_contrastText: '#FFFFFF',
  theme_light_secondary_contrastText: '#FFFFFF'
};

export default config;
